import { h } from "preact";
import { trimText } from "../utils";

export function TrimmedText(props: { children: string, maxLength: number, tooltip?: boolean, class?: string, style?: string }) {
    return props.children.length <= props.maxLength ? <span class={props.class} style={props.style}>{props.children}</span>
        : props.tooltip ? <span class={props.class + " tooltip"} style={props.style} data-tooltip={props.children}>
            {trimText(props.children, props.maxLength)}
        </span>
        : <span class={props.class} style={props.style}>
            {trimText(props.children, props.maxLength)}
        </span>;
}
